// extracted by mini-css-extract-plugin
export default {"container":"DeviceList_container__hSsuC","name":"DeviceList_name__O1aKN","item":"DeviceList_item__iUEuG","loader":"DeviceList_loader__bWVwE"};